(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("datautils", [], factory);
	else if(typeof exports === 'object')
		exports["datautils"] = factory();
	else
		root["datautils"] = factory();
})(global, () => {
return 